import { render, staticRenderFns } from "./LoginAlerts.vue?vue&type=template&id=377632bb"
import script from "./LoginAlerts.vue?vue&type=script&lang=js"
export * from "./LoginAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports